import { Theme, teamsLightTheme, teamsDarkTheme } from '@fluentui/react-components';

const light = { ...teamsLightTheme };
light.colorBrandBackground = 'var(--brand-60)';  // Use CSS token
light.colorBrandBackground2 = 'var(--brand-50)';  // Use CSS token
light.colorBrandForeground1 = 'var(--brand-80)';  // Use CSS token
light.colorBrandStroke1 = 'var(--brand-70)';      // Use CSS token
light.colorBrandForegroundLink = 'var(--brand-70)'; // Use CSS token
light.borderRadiusLarge = 'var(--radius-lg)';
light.borderRadiusMedium = 'var(--radius-md)';
light.borderRadiusCircular = 'var(--radius-full)';
(light as any).colorBrandAlt = 'var(--brand-accent-60)';     // Use CSS token
(light as any).colorBrandGreen = 'var(--brand-green)';       // Use CSS token
(light as any).colorBrandBlue = 'var(--brand-blue)';         // Use CSS token
(light as any).colorBrandDark = 'var(--brand-dark)';         // Use CSS token
(light as any).colorBrandPurple = 'var(--brand-purple)';     // Use CSS token

const dark = { ...teamsDarkTheme };
dark.colorBrandBackground = 'var(--brand-60)';  // Use CSS token
dark.colorBrandBackground2 = 'var(--brand-50)';  // Use CSS token
dark.colorBrandForeground1 = 'var(--brand-30)';  // Use CSS token
dark.colorBrandStroke1 = 'var(--brand-40)';      // Use CSS token
dark.colorBrandForegroundLink = 'var(--brand-30)'; // Use CSS token
dark.borderRadiusLarge = 'var(--radius-lg)';
dark.borderRadiusMedium = 'var(--radius-md)';
dark.borderRadiusCircular = 'var(--radius-full)';
(dark as any).colorBrandAlt = 'var(--brand-accent-60)';     // Use CSS token
(dark as any).colorBrandGreen = 'var(--brand-green)';       // Use CSS token
(dark as any).colorBrandBlue = 'var(--brand-blue)';         // Use CSS token
(dark as any).colorBrandDark = 'var(--brand-dark)';         // Use CSS token
(dark as any).colorBrandPurple = 'var(--brand-purple)';     // Use CSS token

export const brandLightTheme: Theme = light;
export const brandDarkTheme: Theme = dark;
